import React, { useEffect, useState } from "react";
import Pulse from "../Loader/Pulse";
import ServerRequest from "../../exports/ServerRequest";
import { GetCookie } from "../../exports/CookieManagement";
import { numberFormat } from "../../exports/UtilFunctions";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import { ArrowDown2, ArrowUp2 } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import { getDeviceSize } from "../../exports/InteractiveUtils";

const DEVICE_SIZE = getDeviceSize();

const Filter = () => {
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading data...");
  const [loadingPage, setLoadingPage] = useState(true);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [data, setData] = useState();
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    fetchCategory();
  }, []);
  useEffect(() => {
    fetchData();
  }, [selectedCategory]);

  const account_token = GetCookie("token");

  const fetchCategory = async () => {
    setLoadingPage(true);
    const response = await ServerRequest({
      url: `/mf/filter/category?token=${account_token}`,
      method: "get",
      //  signal: signal,
    });

    setCategory(response.data);
    setTimeout(() => {
      setLoadingPage(false);
    }, 1000);
  };
  const fetchData = async () => {
    if (!selectedCategory) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setLoadingText("Loading data...");
    const encodedCategory = encodeURIComponent(selectedCategory);

    const response = await ServerRequest({
      url: `/mf/filter/category/data?token=${account_token}&category=${encodedCategory}`,
      method: "get",
      //  signal: signal,
    });
    setSortConfig({ key: "", direction: "" });
    setData(response.data);
    setSortedData(response.data);
    // setTimeout(() => {
    setLoading(false);
    // }, 1000);
  };
  const handleClick = async (symbol) => {
    setLoading(true);
    setLoadingText("Adding To Watchlist ...");

    const response = await ServerRequest({
      url: `/mf/add?token=${account_token}`,
      data: symbol,
      method: "post",
      //  signal: signal,
    });
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  function SortCell(title, value) {
    return (
      <div>
        <p>{title}</p>
        {getSortIcon(value)}
      </div>
    );
  }

  useEffect(() => {
    const sortData = () => {
      if (sortConfig.key) {
        return [...data].sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
    };
    const sortedData = sortData();
    if (sortedData) setSortedData(sortedData);
  }, [data, sortConfig]);

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        return <ArrowUp2 size={14} color={COLOR_VARS["SWIFT_COLOR4"]} />;
      } else if (sortConfig.direction === "descending") {
        return <ArrowDown2 size={14} color={COLOR_VARS["SWIFT_COLOR4"]} />;
      }
    }
    return "";
  };

  return (
    <div className="mf-wrapper">
      {loadingPage ? (
        <>
          <div className="mf-loading">
            <Pulse />
{/* <p>Loading data...</p> */}
          </div>
        </>
      ) : (
        <>
          <CustomSelect
            heading="Select Category"
            defaultIndex={category.indexOf(selectedCategory)}
            options={category}
            width={240}
            height={40}
            placeholder="Select Category"
            onTypeChange={(value) => {
              setSelectedCategory(value);
            }}
          />
          <div className="mf-container mf-watchlist-container mf-filter-container">
            {loading ? (
              <>
                <div className="mf-loading">
                  <Pulse />
{/* <p>{loadingText}</p> */}
                </div>
              </>
            ) : (
              <>
                {!data ? (
                  <div className="mf-empty">
                    <div>
                      <p>Please select a category</p>
                      <span>Looks like you haven't selected any category.</span>
                    </div>
                  </div>
                ) : (
                  <>
                    {data.length === 0 ? (
                      <div className="mf-empty">
                        <div>
                          <p>No Data found</p>
                          <span>
                            Looks like we don't have any Mutual Funds yet for
                            the selected category.
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>
                        {DEVICE_SIZE == "S" ? (
                          <>
                            {sortedData.map((s, index) => {
                              return (
                                <MFCard
                                  key={index}
                                  data={s}
                                  handleClick={handleClick}
                                />
                              );
                            })}
                          </>
                        ) : (
                          <>
                            <table>
                              <thead>
                                <tr>
                                  <td
                                    className="isin"
                                    onClick={() => requestSort("ISIN")}
                                  >
                                    {SortCell("ISIN", "ISIN")}
                                  </td>
                                  <td
                                    className="scheme-name"
                                    onClick={() => requestSort("Scheme_Name")}
                                  >
                                    {SortCell("Scheme Name", "Scheme_Name")}
                                  </td>
                                  <td
                                    className="category"
                                    onClick={() =>
                                      requestSort("Scheme_Category")
                                    }
                                  >
                                    {SortCell("Category", "Scheme_Category")}
                                  </td>
                                  <td
                                    className="1-month"
                                    onClick={() => requestSort("Month_1")}
                                  >
                                    {SortCell("1 Month", "Month_1")}
                                  </td>
                                  <td
                                    className="3-month"
                                    onClick={() => requestSort("Month_3")}
                                  >
                                    {SortCell("3 Month", "Month_3")}
                                  </td>
                                  <td
                                    className="6-month"
                                    onClick={() => requestSort("Month_6")}
                                  >
                                    {SortCell("6 Month", "Month_6")}
                                  </td>
                                  <td
                                    className="12-month"
                                    onClick={() => requestSort("Year_1")}
                                  >
                                    {SortCell("1 Year", "Year_1")}
                                  </td>
                                  <td
                                    className="3-year"
                                    onClick={() => requestSort("Year_3")}
                                  >
                                    {SortCell("3 Year", "Year_3")}
                                  </td>
                                  <td className="hover-td"></td>
                                </tr>
                              </thead>
                              <tbody>
                                {sortedData.map((h, index) => {
                                  return (
                                    <tr key={index} className="yes_hover">
                                      <td title={h["ISIN"]}>{h["ISIN"]}</td>
                                      <td title={h.Scheme_Name}>
                                        {h["Scheme_Name"]}
                                      </td>
                                      <td title={h.Scheme_Category}>
                                        {h["Scheme_Category"]}
                                      </td>
                                      {ColorClassTD(h.Month_1)}
                                      {ColorClassTD(h.Month_3)}
                                      {ColorClassTD(h.Month_6)}
                                      {ColorClassTD(h.Year_1)}
                                      {ColorClassTD(h.Year_3)}
                                      <td>
                                        <div className="hover-container">
                                          <div
                                            className="hover-btn"
                                            onClick={() => {
                                              handleClick(h);
                                            }}
                                          >
                                            Add Watchlist
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

function ColorClassTD(value) {
  if (value == "--") {
    return <td>--</td>;
  }
  return (
    <td className={parseInt(value) >= 0 ? "positive" : "negative"}>
      {numberFormat(value)}
    </td>
  );
}

function MFCard({ data, handleClick }) {
  const {
    ISIN,
    Scheme_Type,
    Scheme_Name,
    RTA_Agent_Code,
    Month_1,
    Month_3,
    Year_1,
    Year_3,
  } = data;

  function GetReturns(value) {
    if (value == "--") {
      return <span>--</span>;
    }
    return (
      <span className={parseFloat(value) >= 0 ? "positive" : "negative"}>
        {numberFormat(value)}
      </span>
    );
  }

  return (
    <div className="mf-watchlist-card">
      <div className="mfwc-info">
        <div className="isin-price">
          <p className="isin-type">
            {ISIN}&nbsp;|&nbsp;{Scheme_Type}
          </p>
        </div>
        <p className="name">
          {Scheme_Name} - {RTA_Agent_Code}
        </p>
      </div>
      <div className="mfwc-config">
        <div className="mfwc-config-row">
          <p>1 Month{GetReturns(Month_1)}</p>
          <p>3 Month{GetReturns(Month_3)}</p>
        </div>
        <div className="mfwc-config-row">
          <p>1 Year{GetReturns(Year_1)}</p>
          <p>3 Year{GetReturns(Year_3)}</p>
        </div>
      </div>
      <div className="mfwc-buttons">
        <div
          className="hover-btn"
          onClick={() => {
            handleClick(data);
          }}
        >
          Add Watchlist
        </div>
      </div>
    </div>
  );
}

export default Filter;
